import { WORK_TYPE_OPTIONS } from '@/features/gnmk/constants/workTypeEnums.js';

export { WORK_TYPE_OPTIONS };

// 早期由任务同步写入的日志使用英文全称，读取时统一切换到短码，避免历史数据在列表和表单中显示为空。
const LEGACY_WORK_TYPES = {
  maintenance: 'wb',
  test: 'cs',
  patrol: 'xc'
};

export function normalizeWorkType (value) {
  return LEGACY_WORK_TYPES[value] || value || 'wb';
}

export function formatWorkType (value) {
  if (!value) return '-';
  const normalized = LEGACY_WORK_TYPES[value] || value;
  const option = WORK_TYPE_OPTIONS.find(item => item.value === normalized);
  // 后端新增枚举时会先于前端字典上线，此处回退展示原始值，避免出现空白单元格。
  return option ? option.label : value;
}

// 标签配色的键与枚举值同名，未知枚举落到 default 主题，保证样式类始终有对应定义。
export function workTypeTheme (value) {
  const normalized = LEGACY_WORK_TYPES[value] || value;
  const known = WORK_TYPE_OPTIONS.some(item => item.value === normalized);
  return known ? normalized : 'default';
}

// 旧日志尚未回填处理类型时，维修事件优先于故障单创建标记。
export function normalizeProcessType (record) {
  if (record.processType) return record.processType;
  if (record.sourceAction === 'fault_repair') return 'repair_completed';
  return record.faultCreatedFlag === 'Y' || record.faultCode ? 'fault_created' : 'normal';
}
